import { getStore } from 'store';
import { setGlobal } from 'store/global/reducer';
import { UPLOAD_FILE_FAILED } from 'utility/frontendMessage';
import { handleFileVirus } from 'utility/general';
import API from './index';

const api = {
    uploadDocument(fileContent) {
        let uploadUrl = '/file/upload-document';

        // if local development, use this endpoint to skip api-gateway virus checking
        if (process.env.NODE_ENV === 'development') {
            uploadUrl = '/file/upload-document-without-gateway';
        }

        return API.authAPI({
            url: uploadUrl,
            method: 'POST',
            data: fileContent,
            timeout: 1000 * 60 * 10,
        }).catch((error) => {
            if (error?.response?.status === 400) {
                const { hasVirus, fileName } = handleFileVirus(error);
                const { dispatch } = getStore();

                if (hasVirus) {
                    dispatch(
                        setGlobal({
                            isShowConfirmModal: true,
                            modalDescription: `Virus has been detected in "${fileName}", please remove the file and try again`,
                        }),
                    );
                } else {
                    dispatch(
                        setGlobal({
                            isShowConfirmModal: true,
                            modalDescription: UPLOAD_FILE_FAILED,
                        }),
                    );
                }
            } else {
                const store = getStore();

                store.dispatch(
                    setGlobal({
                        isErrorShow: true,
                        errorMessage: 'File upload failed, please try again',
                        isGlobalLoadingShow: false,
                        errorTitle: 'Reminder',
                    }),
                );
            }

            throw error;
        });
    },
    downloadDocument(data) {
        return API.authAPI({
            url: `/application/download-document/${data.type}/${data.id}`,
            method: 'GET',
            responseType: 'blob',
            timeout: 1000 * 60 * 10,
        });
    },
    downloadGenerateDoc({ id, type, data }) {
        let url = `/generate/generate-doc/${id}?type=${type}`;
        if (data?.decision) {
            url = url + `&decision=${data.decision}`;
        }
        if (data?.refNo) {
            url = url + `&refNo=${data.refNo}`;
        }

        return API.authAPI({
            url: url,
            method: 'GET',
            responseType: 'blob',
            timeout: 1000 * 60 * 10,
        }).catch(async (error) => {
            const errorMessage = await error.response?.data?.text();

            if (errorMessage.includes('You do not have premission to access this form.')) {
                getStore().dispatch(
                    setGlobal({
                        isErrorShow: true,
                        errorMessage: `You don't have the permission to download the initial application form`,
                        isGlobalLoadingShow: false,
                        errorTitle: 'Reminder',
                    }),
                );
            }

            throw error;
        });
    },
    exportApplicationSearch(data) {
        return API.authAPI({
            url: '/generate/export-application-search',
            method: 'POST',
            responseType: 'blob',
            timeout: 1000 * 60 * 10,
            data,
        });
    },
    exportApplicationSearchNTEC(data) {
        return API.authAPI({
            url: '/generate/export-for-ntec',
            method: 'POST',
            responseType: 'blob',
            timeout: 1000 * 60 * 10,
            data,
        });
    },
    exportApplication({ data }) {
        return API.authAPI({
            url: `/generate/export-application`,
            method: 'POST',
            responseType: 'blob',
            timeout: 1000 * 60 * 10,
            data,
        });
    },
    exportForCCO({data, type}) {
        return API.authAPI({
            url: `/generate/export-template/${type}`,
            method: 'POST',
            responseType: 'blob',
            timeout: 1000 * 60 * 10,
            data,
        });
    },
};

export default api;
